<template>
  <div>
    <emptyshop-header :list="empshopList" v-transition></emptyshop-header>
    <emptyshop-footer v-transition></emptyshop-footer>
  </div>
</template>

<script>
import EmptyshopHeader from './components/Header'
import EmptyshopFooter from './components/Footer'
export default {
  name: 'Emptyshop',
  components: {
    EmptyshopHeader,
    EmptyshopFooter
  },
  data () {
    return {
      empshopList: []
    }
  },
  methods: {
    getEmptInfo () {
      this.axios.get('/ApiEmptyCart/GetSynthetic')
        .then(this.getEmptInfoSucc)
        .catch(this.getEmptInfoFail)
    },
    getEmptInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.empshopList = JSON.parse(data.empshopList)
      }
    },
    getEmptInfoFail () {
      alert('获取数据失败')
    }
  },
  mounted () {
    this.getEmptInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/empty_shopping/Emptyshop.vue